import { OrderedMap } from 'immutable';
import { EOgqlJobState, IOgqlJobResult } from '@opengov/ogql-types';
import { removeNoCodes } from '@opengov/reporting-transforms/visualizations';
import { EQueryType } from '@opengov/reporting-types';
import sortBy from 'lodash/sortBy';

import { reportDataTableAgGridActionCreators } from '../../../../reportExplorer/ReportDataTableAgGrid/state';
import { IReportLocale } from '../../../locale';
import { MuiToastTypes } from '../../../helpers/utils';
import { reportActionCreators } from '../../../report/state';
import { runV0Query } from './runQueries';

export const columnSearchQuery = async (params: {
  reportConfiguration;
  stringToSearchFor: string;
  column: any;
  reportMsgs: IReportLocale;
  useLargeScaleQueryLimit: boolean;
  useQueryService: boolean;
  templateId: string;
  lensId: string;
  isStandardTemplate: boolean;
}) => {
  const {
    column,
    stringToSearchFor,
    reportConfiguration,
    useLargeScaleQueryLimit,
    reportMsgs,
    useQueryService,
    templateId,
    lensId,
    isStandardTemplate
  } = params;
  return runV0Query({
    templateId,
    lensId,
    reportId: reportConfiguration.reportId,
    queryType: EQueryType.columnSearchQuery,
    body: { column, stringToSearchFor, reportConfiguration },
    useLargeScaleQueryLimit,
    useQueryService,
    isStandardTemplate
  })
    .then((result) => {
      return handleColumnSearchQueryResult(result, reportMsgs, stringToSearchFor, column?.name ?? '');
    })
    .catch((_e) => {
      reportActionCreators.toggleMuiToast({
        type: MuiToastTypes.FAILURE,
        headerText: reportMsgs.reportExplorer.filters.columnSearchErrorToast.header,
        bodyText: reportMsgs.reportExplorer.filters.columnSearchErrorToast.body({ searchString: stringToSearchFor })
      });
    });
};

const removeNoCodesFromRow = (row: any[]) => {
  return row.map((val) => {
    return removeNoCodes(val, '');
  });
};

export const handleColumnSearchQueryResult = (
  result: IOgqlJobResult,
  reportMsgs: IReportLocale,
  stringToSearchFor: string,
  columnName: string
) => {
  switch (result.state) {
    case EOgqlJobState.finished: {
      if (Array.isArray(result?.jobResult?.data[0]) && result?.jobResult?.data[0].length === 0) {
        reportDataTableAgGridActionCreators.setFilterValuesByColumn({
          columnName,
          filterValues: OrderedMap<string, number>()
        });
        return [];
      }
      const noCodeRemoved = sortBy(result?.jobResult?.data)
        .map((row) => removeNoCodesFromRow(row))
        .filter((row) => row[0] !== '') as [string, number][];
      reportDataTableAgGridActionCreators.setFilterValuesByColumn({
        columnName,
        filterValues: OrderedMap<string, number>(noCodeRemoved)
      });

      return noCodeRemoved;
    }
    case EOgqlJobState.failed: {
      reportActionCreators.toggleMuiToast({
        type: MuiToastTypes.FAILURE,
        headerText: reportMsgs.reportExplorer.filters.columnSearchErrorToast.header,
        bodyText: reportMsgs.reportExplorer.filters.columnSearchErrorToast.body({ searchString: stringToSearchFor })
      });
      return [];
    }
    case EOgqlJobState.cancelled:
    default:
      return [];
  }
};
